import { ColumnDataType, Resource } from '../../shared/model/resource';

export const adminEmailsResource: Resource = {
    disableDelete: true,
    disableEdit: true,
    disableNew: true,
    nomeEntidade: {
        singular: 'E-mail',
        plural: 'E-mails'
    },
    fieldPk: 'uuid',
    route: {
        url: 'admin/emails'
    },
    colunas: [
        {
            field: 'destinatario',
            label: 'Destinatário'
        },
        {
            field: 'tipo',
            label: 'Tipo'
        },
        {
            field: 'ultimo_envio',
            label: 'Último envio',
            type: ColumnDataType.Date,
        },
        {
            field: 'erro',
            label: 'Erro',
            calculateDisplayValue: (erro: string | null) => {
                return erro || '-';
            }
        }
    ],
    actions: [],
    availableReferences: []
};
